var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gw-entity-filter-item',{attrs:{"display-text":_vm.displayText,"property-name":_vm.propertyName,"representation-field":"nome","search":_vm.finder,"selection-support":_vm.listing,"find-values":_vm.findValues},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var entity = ref.entity;
return undefined}}])})}
var staticRenderFns = []

export { render, staticRenderFns }